import PropTypes from "prop-types";

const SocialIcon = ({ link, icon }) => (
  <a
    className={`tw-flex tw-justify-center tw-items-center tw-w-[38px] tw-h-[38px] tw-rounded-full hover:tw-no-underline ${link ? "tw-text-white hover:tw-text-white tw-bg-theme-primary" : "tw-text-gray-50 hover:tw-text-gray-50 tw-bg-gray-15"}`}
    href={link ? `${link.indexOf("://") === -1 ? "https://" : ""}${link}` : ""}
    target="_blank"
    onClick={(e) => !link && e.preventDefault()}
    rel="noopener noreferrer"
    alt="Social Icon"
  >
    <i className={icon} />
  </a>
);

SocialIcon.propTypes = {
  link: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

SocialIcon.defaultProps = {
  link: "",
};

export default SocialIcon;
